// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCACxLPXGWkMy_WisCCpDvFj_aTBkLZC8A",
  authDomain: "email-password-auth-48ea7.firebaseapp.com",
  projectId: "email-password-auth-48ea7",
  storageBucket: "email-password-auth-48ea7.appspot.com",
  messagingSenderId: "604649405272",
  appId: "1:604649405272:web:901157e1fb5bfda1a0832d"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;